import React, { Component } from "react";
import { Form, Modal } from "reactstrap";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
//import Cargando from '../../../components/Generales/ModalCargando';
import ModalCargando from "../../../components/Generales/ModalCargando";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'; 
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { Save, DeleteForever, Clear, Add, Close, ArrowForward, ArrowForwardIos, DesktopAccessDisabledSharp } from "@material-ui/icons";
import { parsePhoneNumberFromString, parsePhoneNumber, format, formatNumber } from "libphonenumber-js";
import moment from 'moment';
import cookie from 'js-cookie'
import SeleccionarMaestro from "../../Generales/ComponentesEmpresas/SeleccionarMaestro";
import ModalPreguntaEditable from "../../Generales/ComponentesEmpresas/ModalPreguntaEditable";
import ModalDardeBajaAlumno from "./ModalDardeBajaAlumno";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { number, object } from "prop-types";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from "@material-ui/core/IconButton";

class ModalAsignarGrupo extends Component {

  constructor(props, context) {
    super(props, context);
    this.escFunction = this.escFunction.bind(this);
    this.state = {
      GrupoSeleccionado: {},
      InfoGrupo: [],
      DiasSemana: ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"],
      disabled:false,
      colorNotificacion: "success",
      mensaje: "",
      br: false,
      aviso: "",
      pregunta: 0,
      CuerpoCargando: "Cargando",
      
    }
    this.handleChange = this.handleChange.bind(this);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick(false);
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    //console.log(this.props.GrupoSeleccionado)
    this.ObtenerInformacionGrupo(this.props.GrupoSeleccionado._idGrupo)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

async ObtenerInformacionGrupo(idGrupo) {
  this.setState({cargando: true});
  await fetch(Globales.Url + 'Calificaciones/Calificaciones/ObtenerInformacionGrupo', {
      method: 'POST',
      headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({idGrupo: idGrupo})
  }
  ).then(res => res.json())
      .then(data => {
          //console.log("ObtenerInformacionGrupo: ", data.InfoGrupo);
          if (data.error) { //Error en la respuesta
              this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", Activo: 1, cargando: false });
              this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ InfoGrupo: data.InfoGrupo, cargando: false});
          }
        })
  .catch(err => this.setState({mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true}));
}

handleChange(e) {
  const { name, value } = e.target;

  this.setState({[name]: value});
}

cerrarModal = () => {
  this.props.eventClick(false)
}
 
  render() {
    const { classes } = this.props;
    const { InfoGrupo } = this.state;

    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando
          Cuerpo={this.state.CuerpoCargando}
          show={this.state.cargando}
        />
      );
    }

    let DiasClase = [];
    let Horario = "";
    if(Object.keys(InfoGrupo).length !== 0){
      if(InfoGrupo.HorarioGrupo.Lunes == "true"){
        DiasClase.push("Lunes")
      }
      if(InfoGrupo.HorarioGrupo.Martes == "true"){
        DiasClase.push("Martes")
      }
      if(InfoGrupo.HorarioGrupo.Miercoles == "true"){
        DiasClase.push("Miercoles")
      }
      if(InfoGrupo.HorarioGrupo.Jueves == "true"){
        DiasClase.push("Jueves")
      }
      if(InfoGrupo.HorarioGrupo.Viernes == "true"){
        DiasClase.push("Viernes")
      }
      if(InfoGrupo.HorarioGrupo.Sabado == "true"){
        DiasClase.push("Sabado")
      }

      if(InfoGrupo.HorarioGrupo.HoraInicio !== undefined && InfoGrupo.HorarioGrupo.HoraInicio !== null){
        Horario = `De ${moment(InfoGrupo.HorarioGrupo.HoraInicio, "hh:mm").format("hh:mm")} ${InfoGrupo.HorarioGrupo.FormatoInicio}`
      }
      if(InfoGrupo.HorarioGrupo.HoraFin !== undefined && InfoGrupo.HorarioGrupo.HoraFin !== null){
        Horario += ` a ${moment(InfoGrupo.HorarioGrupo.HoraFin, "hh:mm").format("hh:mm")} ${InfoGrupo.HorarioGrupo.FormatoFin}`
      }
    }

    let info = "";
    if(DiasClase.length !== 0){
      DiasClase.map((dia, index) => {
        if(index !== DiasClase.length -1){
          info += dia + ", "
        }
        else{
          info += dia
        }
      })
    }
    else{
      info = "Sin especificar"
    }

    return (
      <div>
        <Modal
          isOpen={this.props.showInfoGrupo}
          className="static-modal"
          size="md"
          toggle={this.cerrarModal}
          backdrop={true}
        >
          <Card>
            <CardHeader color="info">{this.props.Titulo}</CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer>
                    <GridItem xs={3} sm={3} md={3}>
                      <p><b style={{fontWeight: "bold"}}>GRUPO: </b></p>
                      <p><b style={{fontWeight: "bold"}}>AULA: </b></p>
                      <p><b style={{fontWeight: "bold"}}>MAESTRO: </b></p>
                      <p><b style={{fontWeight: "bold"}}>DIAS: </b></p>
                      <p><b style={{fontWeight: "bold"}}>HORARIO: </b></p>
                    </GridItem>
                    <GridItem xs={9} sm={9} md={9}>
                      <p>{InfoGrupo.Nombre}</p>
                      <p>{InfoGrupo.NombreAula}</p>
                      <p>{InfoGrupo.NombreMaestro !== null && InfoGrupo.NombreMaestro !== undefined ? InfoGrupo.NombreMaestro : "Sin especificar"}</p>
                      <p>{info}</p>
                      <p>{Horario !== "" ? Horario : "Sin especificar"}</p>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
          <GridItem xs={12} sm={12} md={12}>
              <Button tabIndex="1" size='sm' className='pull-right ml-2 mt-3' round onClick={() => this.props.eventClick(false)}><Clear/>&nbsp;Cerrar</Button>
          </GridItem> 
        </Modal>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
          {agregar}
        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(ModalAsignarGrupo);